window.onload = function() {
   var header = document.querySelector(".theme__header");
   var content = document.querySelector(".collection__nav");
   var headerHeight = header.getBoundingClientRect().height;
   var contentTop = content.getBoundingClientRect().top;
   var fixed = false;

   window.addEventListener("scroll", function() {
      if (window.scrollY > contentTop - headerHeight && !fixed) {
         content.classList.add("fixed");
         content.style.top = headerHeight + "px";
         fixed = true;
      } else if ((window.scrollY <= contentTop - headerHeight || window.scrollY < headerHeight) && fixed) {
         content.classList.remove("fixed");
         content.style.top = "";
         fixed = false;
      }
   });
}
